/** Matches prototype's .field-label — flex space-between, 13px, 700, uppercase, 0.5px tracking. */
export function FieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="flex items-center justify-between font-lato font-bold uppercase text-rodeo-black"
      style={{ fontSize: 13, letterSpacing: "0.5px", marginBottom: 6 }}
    >
      {children}
    </div>
  );
}
